export const setCookie = (name, value) => {
  const cookie = `${name}=${JSON.stringify(value)}`;
    
  document.cookie = cookie;
};

export const deleteCookie = (name, value) => {
  const cookie = `${name}=${JSON.stringify(value)}; expires = Thu, 01 Jan 1970 00:00:00 GMT`;
    
  document.cookie = cookie;
};

